import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/tick.svg';
import { mapGetters } from 'vuex';
import optinProductAvailabilityMutation from '@/graphql/mutation/optinProductAvailability.gql';
import isNewProduct from '~/const/patch/newProducts';
import { validateEmail } from '~/helpers/validation-helper';
export default {
  name: 'TheEmailForm',
  props: {
    locale: {
      type: Object,
      required: true
    },
    reference: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      userEmail: '',
      hasError: false,
      isComplete: false,
      needsChecking: false,
      alertFormMessage: '',
      xhrUri: ''
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    sharedEnv: 'sharedEnv/getSharedEnv'
  })), {}, {
    comingSoonLabel() {
      return isNewProduct(this.reference) ? 'new_product_stock' : 'product_stock';
    }

  }),
  methods: {
    handleBlur(event) {
      if (event.target.value === '') {
        this.hasError = false;
      }

      if (!this.isComplete && event.target.value !== '') {
        this.needsChecking = true;
        this.checkEmail();
      }
    },

    checkIfComplete() {
      this.isComplete = validateEmail(this.userEmail);
    },

    checkEmail() {
      this.hasError = !validateEmail(this.userEmail);
      this.isComplete = !this.hasError;
      return this.isComplete ? validateEmail(this.userEmail) : null;
    },

    createAlertDispo() {
      // Quick sanitize before posting email value
      if (!validateEmail(this.userEmail)) {
        return;
      }

      this.$apolloProvider.defaultClient.mutate({
        mutation: optinProductAvailabilityMutation,
        variables: {
          locale: this.locale.iso,
          reference: this.reference,
          email: this.userEmail
        }
      }).then((_ref) => {
        var {
          data: {
            optinProductAvailability: isSuccess
          }
        } = _ref;
        this.alertFormMessage = isSuccess ? 'product_form_confirm' : 'product_form_error';
      });
    }

  }
};